import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import cookieManager from "../../components/CookieManager";
import LoginHelper from "../../components/LoginHelper";
import Localize from "../../components/Localize/Localize";
import LocalizeKeys from "../../components/Localize/LocalizeKeys";
import Constants from "../../components/Constants";
import RemoteConfigService from "../../components/RemoteConfigService";
import NavBar from "../../screens/NavBar/NavBar";
import "./Login.css";
import TriggerActionService from "../../components/TriggerActionService";
import ActionTriggerConstants from "../../components/ActionTriggerConstants";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
     // Fire-and-forget async trigger action
      TriggerActionService.sendTriggerAction(ActionTriggerConstants.LANDING_OPEN, "", {
          sourceUrl: "Login"
      }).catch((e) => {
          console.warn("[-] TriggerActionService failed", e);
      });

    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get(Constants.ACCESS_TOKEN);
    const refreshToken = queryParams.get(Constants.REFRESH_TOKEN);
    const skillsId = queryParams.get(Constants.SKILLS_ID);
    const lang = queryParams.get(Constants.LANG);

    const setLanguageAndNavigate = async () => {
      // If the url has accessToken as a parameter, store it in a cookie and redirect to dashboard
      if (accessToken) {
        cookieManager.remove(Constants.ACCESS_TOKEN);
        cookieManager.remove(Constants.REFRESH_TOKEN);
        cookieManager.remove(Constants.SKILLS_ID);

        cookieManager.set(Constants.ACCESS_TOKEN, accessToken);
        if (refreshToken) cookieManager.set(Constants.REFRESH_TOKEN, refreshToken);
        if (skillsId) cookieManager.set(Constants.SKILLS_ID, skillsId);
        console.log("[Login] The url has accessToken: ", accessToken);

        if (lang) {
          console.log("[Login] Set language by params: ", lang);
          await Localize.setLanguage(lang);
        } else {
          await Localize.setLanguageFromBrowser();
        }
        
        await RemoteConfigService.init();
        
        navigate("/dashboard");
        return;
      }

      // If the user is already logged in, redirect to dashboard
      const accessTokenCookie = cookieManager.get(Constants.ACCESS_TOKEN);
      if (accessTokenCookie) {
        navigate("/dashboard");
      }
    };

    setLanguageAndNavigate();
  }, [location, navigate]);
  
  // Default login with user and password
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await LoginHelper.LoginWithUserAndPassword(
          username,
          password
      );

      if (response.profile.country !== "") {
        const lan = Localize.getLanguageByCountry(response.profile.country);
        console.log("Change language by country, country:", response.profile.country, "lan:", lan);
        await Localize.setLanguage(lan);
      } else {
        await Localize.setLanguageFromBrowser();
      }

      await RemoteConfigService.init();

      navigate("/play");
    } catch (err) {
      console.error("Error:", err);
      setError(Localize.translate(LocalizeKeys.LOGIN_ERROR));
    }
  };

  return (
      <div>
        <NavBar showLogout={false} showPlay={false} />
        <div className="login-container">
          <div className="login-card">
            <h2>{Localize.translate(LocalizeKeys.LOGIN_TITLE)}</h2>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label htmlFor="username">
                  {Localize.translate(LocalizeKeys.LOGIN_USER)}
                </label>
                <input
                    type="text"
                    id="username"
                    placeholder={Localize.translate(
                        LocalizeKeys.LOGIN_USER_PLACEHOLDER
                    )}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <div className="input-group">
                  <label htmlFor="password">{Localize.translate(LocalizeKeys.LOGIN_PASSWORD)}</label>
                  <input
                      type="password"
                      id="password"
                      placeholder={Localize.translate(LocalizeKeys.LOGIN_PASSWORD_PLACEHOLDER)}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                  />
                </div>
              </div>
              <button type="submit" className="login-button">
                {Localize.translate(LocalizeKeys.LOGIN_BUTTON)}
              </button>
            </form>
          </div>
        </div>
      </div>
  );
};

export default Login;
